<div class="d-flex justify-content-between align-items-center">
  <button class="save-button btn btn-primary" (click)="onSubmit()" [disabled]="buttonDisabled()">
    <span class="p-2">{{ "action.save" | translate }}</span>
  </button>
</div>
